import React from "react";
import { useSelector } from "react-redux";
import { HeatmapChart } from "./chart";
import { exportExcelForTimeOfDay } from "../../../../components/heatMap/heatMapUtils";

export const GroupByTimeOfDayChart = () => {
  let series = useSelector((state) => state.utilization.series);

  if (series.length === 0) {
    return (
      <p className="error" style={{ paddingTop: 0 }}>
        No data found for selected date.
      </p>
    );
  }

  return (
    <>
      <div className="chart-addons-control-item">
        <a
          title="Export to Excel"
          onClick={() => {
            exportExcelForTimeOfDay({ seriesGroup: series, groupByTimeOfDay: true });
          }}
        >
          <span className="glyphicon glyphicon-download-alt" />
        </a>
      </div>
      <div className="time-of-day-chart-wrapper">
        {series.map((elem, idx) => {
          const singleData = elem.groupData.length === 1;

          return (
            <div key={idx} className={`time-of-day-chart ${singleData ? "single-data" : ""}`}>
              <HeatmapChart groupByTimeOfDaySeries={elem.groupData} categories={[elem.timeRange]} />
            </div>
          );
        })}
      </div>
    </>
  );
};
